import Slider from './../components/Slider';
import WhatWeDo from './../components/WhatWeDo';
import WhyChoiseUs from './../components/WhyChoiseUs';
import WhoWeAre from './../components/WhoWeAre';
import Review from '../components/Review';
import ScrollToTop from './../components/ScrollToTop';
import ProductRange from './../components/ProductRange';
import StatsSection from './../components/StatsSection';
import BrandsSection from './../components/BrandsSection';
import TestimonialsSection from './../components/TestimonialsSection';
import AboutUsSection from './../components/AboutUsSection';
import BannerSection from './../components/BannerSection';
import React from 'react';

function Home() {
  return (
    <>
      <Slider/>
      <BannerSection />
      <ProductRange />
      <StatsSection />
      <BrandsSection />
      <TestimonialsSection />
      <AboutUsSection />
    </>
  );
}

export default Home;
